import styled, { css } from 'styled-components';

import { getThemeColor } from '@utils/styled';

export const StepperWrapper = styled.ol`
  counter-reset: step;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  list-style: none;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)};

  &::before {
    content: '';
    position: absolute;
    top: 1.5rem;
    left: 1%;
    z-index: -1;
    display: block;
    width: 98%;
    height: 1px;
    background-color: ${getThemeColor('bluegrey.80')};
  }
`;

export const StepButton = styled.button`
  counter-increment: step;
  min-width: 4.2rem;
  margin: 0;
  border: none;
  padding: 0 1rem;
  background-color: ${getThemeColor('grey.100')};
  color: ${getThemeColor('bluegrey.60')};
  font-size: 12px;
  text-align: center;

  &:first-of-type {
    padding-left: 0;
  }

  &:last-of-type {
    padding-right: 0;
  }

  &::before {
    content: counter(step);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.2rem;
    height: 3.2rem;
    margin: 0 auto 0.6rem;
    border: 1px solid ${getThemeColor('bluegrey.95')};
    border-radius: 50%;
    background-color: ${getThemeColor('bluegrey.95')};
    color: ${getThemeColor('bluegrey.60')};
    font-size: 1.6rem;
    line-height: 3.2rem;
  }

  ${({ isClickable }) =>
    isClickable &&
    css`
      color: ${getThemeColor('bluegrey.15')};
      cursor: pointer;

      &::before {
        border: 1px solid ${getThemeColor('bluegrey.15')};
        background-color: ${getThemeColor('grey.100')};
        color: ${getThemeColor('bluegrey.15')};
      }
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${getThemeColor('hue.green')};

      &::before {
        border: 1px solid ${getThemeColor('hue.green')};
        background-color: ${getThemeColor('hue.green')};
        color: ${getThemeColor('grey.100')};
      }
    `}

  &:hover,
  &:focus,
  &:active {
    outline: none;

    &::before {
      background-color: ${({ isActive }) =>
        !isActive && getThemeColor('bluegrey.95')};
    }
  }
`;
